import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FiltersVisibilityService {
  private _isFiltersVisible = signal<boolean>(false);
  private _filterHeight = signal<number>(0);
  public isFiltersVisible = this._isFiltersVisible.asReadonly();
  public filterHeight = this._filterHeight.asReadonly();

  public toggleFiltersVisibility(height: number): void {
    this._isFiltersVisible.set(!this.isFiltersVisible());
    this._filterHeight.set(height);
  }

  public updateFilterHeight(height: number): void {
    this._filterHeight.set(height);
  }

  public resetFilterVisibility(): void {
    this._isFiltersVisible.set(false);
    this._filterHeight.set(0);
  }
}
